<template>

  <div class="mt-1 d-flex flex-wrap">
     <div
      class="ml-8 mb-0" 
      :class="$vuetify.breakpoint.xs ? 'text-h6 mt-4' : 'text-h5 mt-5'">
      <v-icon :large="!$vuetify.breakpoint.xs">
        mdi-file-document-multiple-outline
      </v-icon>
      Documents
    </div>
    <v-col cols="12">
      <v-btn v-for="name in pdfNames"
        :key="name"
        large
        color="primary"
        @click="goToPage('Document', {docName: name})"
        class="my-3 mx-3"
        style="width:320px"
      >
        <span>{{name}}</span>
        <v-spacer />
        <v-icon class="mr">mdi-file-pdf-outline</v-icon>
      </v-btn>

       <v-btn
        large
        color="primary"
        @click="goToPage('Scan Codes')"
        class="my-3 mx-3"
        style="width:320px"
      >
        <span>Scan Codes</span>
        <v-spacer />
        <v-icon class="mr">mdi-file-pdf-outline</v-icon>
      </v-btn>
    </v-col>
  </div>
</template>
<script>
export default {
  computed: {
  },
  data() {
     return {
       pdfNames: ['Installation Instructions', 'Release Notes', "Vision SOP"],
    };
  },
  methods: {
    goToPage(name, params) {
      this.$router.push({name, params});
    }
  }
}
</script>